import { render, staticRenderFns } from "./MilestoneBumpers.vue?vue&type=template&id=70af48e3"
import script from "./MilestoneBumpers.vue?vue&type=script&lang=js"
export * from "./MilestoneBumpers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports